import { Measure } from '@cbsi-cbscom/measure';
import { Metrics } from 'library/ts/utilities/measure/Metrics';
import { AbstractTagClass } from 'tag/ts/tag/abstract/AbstractTagClass';
import { TagAPI } from 'tag/ts/tag/api/TagAPI';
import { VideoAPI } from 'tag/ts/tag/api/VideoAPI';
import { TagEvent } from 'tag/ts/tag/events/TagEvent';
import { TagEventVO } from 'tag/ts/tag/events/TagEventVO';
import { TagLoggerString } from 'tag/ts/tag/model/enums/TagLoggerString';
import { TagErrorCode } from 'tag/ts/tag/model/error/TagErrorCode';
import { EmbedType } from 'tag/ts/tag/model/type/embed/EmbedType';
import { EmbedManager } from 'tag/ts/tag/player/EmbedManager';
import { PlayerManager } from 'tag/ts/tag/player/PlayerManager';
export class TagController extends AbstractTagClass {
    #embedManager;
    #playerManager;
    #tagAPI;
    #videoAPI;
    #failedImports;
    constructor(argument) {
        super({
            ...argument,
            name: 'TagController'
        });
        this.#embedManager = new EmbedManager({
            tag: this.tag,
            onReadyResolve: argument?.onReadyResolve,
            onReadyReject: argument?.onReadyReject
        });
        let playerManagerPromise = new Promise((resolve, reject) => {
            this.#playerManager = new PlayerManager({ tag: this.tag, resolve: resolve, reject: reject });
        }).then((data) => {
            this?.logger?.log('PlayerManager is ready:', data);
            playerManagerPromise = undefined;
            this.#playerManager.initialize().then((data) => {
                this.utils.Delay.delay()
                    .then(() => {
                    this.tagEventsHandler(this.#onTagEvent, [
                        TagEvent.ON_IMPORTS_FAILURE
                    ]);
                    this.loadDependencies().then();
                });
            });
        });
    }
    get playerManager() {
        return this.#playerManager;
    }
    get failedImports() {
        return this.#failedImports;
    }
    get imaLoadFailed() {
        if (this.utils.Type.isEmpty(this.#failedImports)) {
            return false;
        }
        else {
            const importsModule = this.tag.model.config.tag.Imports.params;
            return this.utils.Array.hasObjWithPropValue(this.failedImports, 'namespace', importsModule.ima.namespace);
        }
    }
    get tagAPI() {
        if (this.utils.Type.isUndefined(this.#tagAPI))
            this.#tagAPI = new TagAPI({ tag: this.tag });
        return this.#tagAPI;
    }
    get videoAPI() {
        if (this.utils.Type.isUndefined(this.#videoAPI))
            this.#videoAPI = new VideoAPI({ tag: this.tag });
        return this.#videoAPI;
    }
    loadDependencies = (sessionStart = true) => {
        return new Promise((resolve, reject) => {
            const imports = this.tag.tagUtilities.getImports(this.tag);
            this?.logger?.log('loadDependencies', 'imports:', imports);
            if (sessionStart === true) {
                this.dispatchTagEvent(new TagEventVO(TagEvent.ON_START_DEPENDENCIES_LOAD, this.tag, undefined, this));
            }
            if (sessionStart === true && this?.tag?.params?.SYSTEM?.embedType === EmbedType.DESKTOP) {
                Measure.start(Metrics.importsLoadTime);
            }
            this.utils.Importer.import(imports, true).then((data) => {
                this?.logger?.log('Dependencies import success:', data);
                this.dispatchTagEvent(new TagEventVO(sessionStart === true ? TagEvent.ON_SESSION_START_IMPORTS_DONE : TagEvent.ON_IMPORTS_DONE, this.tag, undefined, this));
                if (sessionStart === true && this?.tag?.params?.SYSTEM?.embedType === EmbedType.DESKTOP) {
                    Measure.end(Metrics.importsLoadTime);
                }
                resolve({ success: true });
            }).catch((error) => {
                this?.logger?.warn('loadDependencies:', 'Dependencies import failure:', error);
                this.dispatchTagEvent(new TagEventVO(TagEvent.ON_IMPORTS_FAILURE, this.tag, error, this));
                reject({ success: false });
            });
        });
    };
    #processDependencyLoadFailure = (error, sessionStart = true) => {
        this.#failedImports = error.imports;
        let ima = false;
        let player = false;
        let imaImportVO;
        let playerImportVO;
        for (let i = 0; i < error.imports.length; i++) {
            if (ima === false) {
                if (error.imports[i].namespace.includes(this.tag.model.config.tag.Imports.params.ad_sdk.ima.namespace)
                    ||
                        error.imports[i].namespace.includes(this.tag.model.config.tag.Imports.params.ad_sdk.ima_dai.namespace)) {
                    ima = true;
                    imaImportVO = error.imports[i];
                }
            }
            if (player === false) {
                if (error.imports[i].namespace.includes(this.tag.model.config.tag.Imports.params.avia.player.namespace)) {
                    player = true;
                    playerImportVO = error.imports[i];
                }
            }
        }
        this?.logger?.warn('Failed imports:', '\nima:', ima, imaImportVO, '\nplayer:', player, playerImportVO);
        const eventVO = this.getTagEventVO(TagEvent.ON_FATAL_ERROR, this.tag, {
            fatalError: {
                code: undefined,
                msg: {
                    original: undefined,
                    custom: undefined
                }
            }
        }, this);
        if (player === true) {
            eventVO.data.fatalError.code = TagErrorCode.DEPENDENCY_LOAD_FAILURE;
            eventVO.data.fatalError.msg.custom = this.tag.errorManager.createErrorMessageByCode(TagErrorCode.DEPENDENCY_LOAD_FAILURE);
            this.dispatchTagEvent(eventVO);
            return;
        }
        if (ima === true) {
            eventVO.data.fatalError.code = TagErrorCode.IMA_LOAD_FAILURE;
            eventVO.data.fatalError.msg.custom = this.tag.errorManager.createErrorMessageByCode(TagErrorCode.IMA_LOAD_FAILURE);
            this.dispatchTagEvent(eventVO);
        }
    };
    #onTagEvent = (event) => {
        switch (event?.type) {
            case TagEvent.ON_IMPORTS_FAILURE:
                this?.logger?.log(TagLoggerString.ON_TAG_EVENT, event?.type, event);
                this.#processDependencyLoadFailure(event?.data);
                break;
        }
    };
}
